import * as moment from "moment";
import * as React from "react";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import { GetTimeAfterHours } from "./GetTimeAfterHours";

export function DistancingCalculator() {
    const [inputDate, setInputDate] = React.useState<string>(
        moment().format(`YYYY-MM-DDTHH:mm`)
    );

    const hoursToAdd = [1, 2, 4, 8, 16, 32, 64, 128];

    return (
        <div
            style={{
                textAlign: `center`,
                margin: "20px",
                borderRadius: "6px",
                background: "rgb(0 0 0 / 15%)",
                padding: "10px",
            }}
        >
            <FormInput
                id={"distancingCalculatorInput"}
                label={"Start"}
                width="230px"
                type="datetime-local"
                value={inputDate}
                onChange={(event) => {
                    setInputDate(event.target.value);
                }}
            />
            {hoursToAdd.map((value) => {
                const timeAfterAddition = GetTimeAfterHours(inputDate, value);

                return (
                    <div key={value}>
                        After {value} hours: {timeAfterAddition}
                    </div>
                );
            })}
        </div>
    );
}
